import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  name: 'GtrColorPicker'
})
export default class GtrColorPicker extends Vue {
  @Prop({ required: false, type: String })
  label: string|undefined

  @Prop({ required: false, type: String })
  value: string|undefined

  @Prop({ required: false, type: Boolean, default: false })
  closeOnClick: boolean | undefined

  @Prop({ required: false, type: Boolean, default: true })
  flat: boolean|undefined

  @Prop({ required: false, type: Boolean, default: false })
  disabled: boolean|undefined

  @Prop({ required: false, type: Boolean, default: true })
  hideSwitch: boolean|undefined

  data () {
    return {
      menu: false,
      localValue: '#FF0000'
    }
  }

  @Watch('value', { immediate: true })
  onValueChange (newVal: string) {
    if (newVal) {
      this.$data.localValue = newVal
    }
  }

  get swatchStyle () {
    const { menu } = this.$data
    return {
      backgroundColor: this.$data.localValue,
      cursor: 'pointer',
      height: '22px',
      width: '22px',
      borderRadius: menu ? '50%' : '4px',
      transition: 'border-radius 200ms ease-in-out',
      marginBottom: '10px',
      border: '1px solid #ddd'
    }
  }

  onInput (color: string) {
    this.$emit('input', color)
  }
}
